module.exports = __webpack_public_path__ + "img/upload-file.ba0a4ee3.svg";